export default "__VITE_ASSET__KE2v3RkP__"